import React from 'react';
import { observer } from 'mobx-react-lite';

const StatisticsItem = observer(({ item, lastRoundValue }) => {
  const { num, count } = item;
  return (
    <div className='statistic-winners-row'>
      <div className='winners-place-container'>
        <span className='place-number'>{num}</span>
      </div>
      <div className='winners-thumb-container'>
        <div className='winners-thumb' style={{ maxWidth: `${(100 * count) / lastRoundValue}%` }} />
      </div>
      <div className='winners-percent-container'>
        <span className='winners-percent-text'>{(100 * count) / lastRoundValue}%</span>
      </div>
    </div>
  );
});

export default StatisticsItem;
